(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["in-header"]) return;
  try {
    
document.addEventListener('click',event=>{if(event.target.closest('.in-mobile-nav a')){document.querySelectorAll('.in-mobile-nav').forEach(menu=>menu.open=false);}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["in-pdp-ingredients"] && !Shopify.designMode) return;
  try {
    
(() => {
  const select = (tab) => {
    const root = tab.closest('[data-pdp-tabs]');
    root.querySelectorAll('[role="tab"]').forEach((item) => {
      const active = item === tab;
      item.setAttribute('aria-selected', String(active));
      item.tabIndex = active ? 0 : -1;
      const panel = root.querySelector(`#${item.getAttribute('aria-controls')}`);
      if (panel) panel.hidden = !active;
    });
  };
  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-pdp-tabs] [role="tab"]');
    if (tab) select(tab);
  });
  document.addEventListener('keydown', (event) => {
    const tab = event.target.closest('[data-pdp-tabs] [role="tab"]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    const tabs = Array.from(tab.parentElement.querySelectorAll('[role="tab"]'));
    const index = tabs.indexOf(tab);
    const next = {
      ArrowLeft: tabs[(index - 1 + tabs.length) % tabs.length],
      ArrowRight: tabs[(index + 1) % tabs.length],
      Home: tabs[0],
      End: tabs[tabs.length - 1],
    }[event.key];
    event.preventDefault();
    next.focus();
    select(next);
  });
  document.addEventListener('shopify:block:select', (event) => {
    const tab = event.target.closest && event.target.closest('[data-pdp-tabs] [role="tab"]');
    if (tab) select(tab);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["in-pdp-main"] && !Shopify.designMode) return;
  try {
    
(() => {
  const setText = (element, value) => {
    if (!element) return;
    element.textContent = value || '';
    if (element.hasAttribute('data-tier-save')) element.hidden = !value;
  };

  const initGallery = (root) => {
    const track = root.querySelector('[data-pdp-track]');
    if (!track) return;
    const slides = Array.from(track.children);
    const thumbs = Array.from(root.querySelectorAll('[data-pdp-thumb]'));
    const current = () => Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
    const go = (index) => {
      const slide = slides[Math.max(0, Math.min(slides.length - 1, index))];
      if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    };
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => go(Number(thumb.dataset.pdpThumb))));
    root.querySelectorAll('[data-pdp-step]').forEach((button) => {
      button.addEventListener('click', () => go(current() + Number(button.dataset.pdpStep)));
    });
    let frame;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const index = current();
        thumbs.forEach((thumb, n) => thumb.setAttribute('aria-current', String(n === index)));
      });
    }, { passive: true });
  };

  const initPurchase = (root) => {
    const form = root.querySelector('[data-pdp-form]');
    if (!form) return;
    const planInput = form.querySelector('[data-pdp-plan]');
    const planNote = form.querySelector('[data-pdp-plan-note]');
    const planName = form.querySelector('[data-pdp-plan-name]');
    const subscribe = form.querySelector('input[name="in_pdp_mode"][value="subscription"]');
    const oneTime = form.querySelector('input[name="in_pdp_mode"][value="onetime"]');
    const addButtons = root.querySelectorAll('[data-pdp-add], [data-pdp-sticky-btn]');
    const compare = root.querySelector('[data-pdp-add-compare]');
    const savings = root.querySelector('[data-pdp-savings]');
    const refills = root.querySelector('[data-pdp-refills]');
    const cadence = (name) => (name || '').replace(/^deliver\s*/i, '');

    // Mobile follows Lymphoria's layout: bundles start as subscriptions.
    if (subscribe && root.dataset.mobileSubscribe === 'true' && window.matchMedia('(max-width: 800px)').matches) {
      subscribe.checked = true;
    }

    const update = () => {
      const checked = form.querySelector('input[name="id"]:checked');
      const tier = checked && checked.closest('.in-pdp-tier').querySelector('[data-tier]');
      if (!tier) return;
      const selected = tier.dataset;
      if (subscribe) {
        subscribe.disabled = !selected.planId;
        if (!selected.planId && subscribe.checked) oneTime.checked = true;
      }
      const subscribed = Boolean(subscribe && subscribe.checked && selected.planId);

      form.querySelectorAll('[data-tier]').forEach((card) => {
        const data = card.dataset;
        const mode = subscribed && data.planId ? 'plan' : 'one';
        setText(card.querySelector('[data-tier-price]'), data[`${mode}Price`]);
        setText(card.querySelector('[data-tier-compare]'), data[`${mode}Compare`]);
        setText(card.querySelector('[data-tier-unit]'), data[`${mode}Unit`]);
        setText(card.querySelector('[data-tier-save]'), data[`${mode}Save`]);
      });

      const mode = subscribed ? 'plan' : 'one';
      root.querySelectorAll('[data-pdp-add-price]').forEach((element) => { element.textContent = selected[`${mode}Price`]; });
      root.querySelectorAll('[data-pdp-sticky-label]').forEach((element) => {
        element.textContent = subscribed ? `${selected.label} · Subscribe & save` : selected.label;
      });
      if (planInput) {
        planInput.disabled = !subscribed;
        planInput.value = subscribed ? selected.planId : '';
      }
      if (planName) planName.textContent = selected.planName || '';
      if (planNote) {
        planNote.hidden = !subscribed;
        planNote.textContent = subscribed
          ? `Renews automatically at ${selected.planPrice} ${cadence(selected.planName)}, plus any shipping and taxes, until you cancel. Skip, pause, or cancel anytime.`
          : '';
      }
      if (compare) compare.textContent = selected[`${mode}Compare`] || '';
      if (savings) {
        const saving = selected[`${mode}Saving`];
        savings.hidden = !saving;
        savings.querySelector('[data-pdp-saving]').textContent = saving || '';
      }
      if (refills) {
        refills.hidden = !subscribed;
        refills.querySelector('[data-pdp-refills-text]').textContent = subscribed ? `Refills ship ${cadence(selected.planName)}` : '';
      }
      addButtons.forEach((button) => { button.disabled = checked.disabled; });
    };

    form.addEventListener('change', update);
    update();
  };

  // Skip the cart: empty it first so checkout holds only the bundle just chosen,
  // even if the shopper comes back and picks a different one.
  const initSkipCart = (root) => {
    const form = root.querySelector('[data-pdp-form]');
    if (!form || root.dataset.skipCart !== 'true') return;
    let sending = false;
    window.addEventListener('pageshow', () => { sending = false; });
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (sending) return;
      sending = true;
      try {
        await fetch(`${(window.Shopify && Shopify.routes && Shopify.routes.root) || '/'}cart/clear.js`, { method: 'POST' });
      } catch (error) {
        // Still go to checkout; an older cart item may remain.
      }
      form.submit();
    });
  };

  const initShipping = (root) => {
    const line = root.querySelector('[data-pdp-ship]');
    if (!line) return;
    const date = new Date();
    for (let added = 0; added < Number(line.dataset.days);) {
      date.setDate(date.getDate() + 1);
      if (date.getDay() !== 0 && date.getDay() !== 6) added += 1;
    }
    line.querySelector('[data-pdp-ship-date]').textContent = date.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
    line.hidden = false;
  };

  const initSticky = (root) => {
    const sticky = root.querySelector('[data-pdp-sticky]');
    const mainButton = root.querySelector('[data-pdp-add]');
    if (!sticky || !mainButton) return;
    // Checked on scroll, so jumps past the button (anchor links, fast flicks) still show the bar.
    const toggle = () => {
      const show = mainButton.getBoundingClientRect().bottom < 0;
      sticky.classList.toggle('is-visible', show);
      sticky.inert = !show;
    };
    let frame;
    window.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(toggle);
    }, { passive: true });
    toggle();
  };

  const init = (root) => {
    if (root.dataset.pdpReady) return;
    root.dataset.pdpReady = 'true';
    initGallery(root);
    initPurchase(root);
    initSkipCart(root);
    initShipping(root);
    initSticky(root);
  };

  const run = () => document.querySelectorAll('[data-in-pdp]').forEach(init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["in-pdp-offer"] && !Shopify.designMode) return;
  try {
    
(() => {
  const run = () => {
    if (!window.matchMedia('(max-width: 800px)').matches) return;
    document.querySelectorAll('[data-pdp-offer][data-mobile-subscribe="true"]').forEach((section) => {
      section.querySelectorAll('.in-pdp-offer-card').forEach((card) => {
        const plan = card.querySelector('[data-offer-plan]');
        const tier = card.querySelector('[data-tier]');
        if (!plan || !tier || !tier.dataset.planId) return;
        plan.disabled = false;
        const data = tier.dataset;
        const set = (selector, value) => {
          const element = tier.querySelector(selector);
          if (!element) return;
          element.textContent = value || '';
          if (element.hasAttribute('data-tier-save')) element.hidden = !value;
        };
        set('[data-tier-price]', data.planPrice);
        set('[data-tier-compare]', data.planCompare);
        set('[data-tier-unit]', data.planUnit);
        set('[data-tier-save]', data.planSave);
        const cadence = card.querySelector('[data-offer-cadence]');
        if (cadence) cadence.hidden = false;
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);

  // Skip the cart: empty it first so checkout holds only this bundle.
  let sending = false;
  window.addEventListener('pageshow', () => { sending = false; });
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!form.matches || !form.matches('[data-pdp-offer][data-skip-cart="true"] .in-pdp-offer-form')) return;
    event.preventDefault();
    if (sending) return;
    sending = true;
    try {
      await fetch(`${(window.Shopify && Shopify.routes && Shopify.routes.root) || '/'}cart/clear.js`, { method: 'POST' });
    } catch (error) {
      // Still go to checkout; an older cart item may remain.
    }
    form.submit();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["in-pdp-stats"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const animate = (element) => {
    const target = parseFloat(element.dataset.countTo);
    const decimals = Number(element.dataset.decimals) || 0;
    if (Number.isNaN(target)) return;
    const start = performance.now();
    const duration = 1400;
    const step = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      element.textContent = (target * eased).toFixed(decimals);
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      entry.target.querySelectorAll('[data-count-to]').forEach(animate);
    });
  }, { threshold: 0.3 });
  const run = () => document.querySelectorAll('[data-pdp-stats]').forEach((section) => observer.observe(section));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["in-product"]) return;
  try {
    
document.addEventListener('click',event=>{const button=event.target.closest('[data-gallery-src]');if(!button)return;const gallery=button.closest('.in-gallery');const image=gallery.querySelector('.in-gallery-image');if(!image)return;image.removeAttribute('srcset');image.src=button.dataset.gallerySrc;image.alt=button.dataset.galleryAlt;gallery.querySelectorAll('[data-gallery-src]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));});
(()=>{const formatMoney=(cents,format)=>{const value=cents/100;const group=(digits,sep)=>digits.replace(/\B(?=(\d{3})+$)/g,sep);const [whole,fraction]=value.toFixed(2).split('.');const rounded=String(Math.round(value));const amounts={amount:`${group(whole,',')}.${fraction}`,amount_no_decimals:group(rounded,','),amount_with_comma_separator:`${group(whole,'.')},${fraction}`,amount_no_decimals_with_comma_separator:group(rounded,'.')};return format?format.replace(/\{\{\s*(\w+)\s*\}\}/,(match,key)=>amounts[key]||amounts.amount):`$${amounts.amount}`;};
const setup=root=>{const form=root.querySelector('.in-product-form');const data=root.querySelector('[data-in-variants]');if(!form||!data||form.dataset.inSubscriptions)return;form.dataset.inSubscriptions='true';const variants=JSON.parse(data.textContent);const money=data.dataset.moneyFormat||'';const moneyWithCurrency=data.dataset.moneyCurrencyFormat||money;const find=selector=>root.querySelector(selector);const idField=form.querySelector('[name="id"]');const planField=find('[data-in-selling-plan]');const subOption=find('[data-in-sub-option]');const subRadio=subOption&&subOption.querySelector('input');const oneRadio=form.querySelector('input[name="in_purchase_type"][value="onetime"]');const note=find('[data-in-sub-note]');const modeLabel=find('[data-in-mode-label]');const oneTimeText=modeLabel?modeLabel.textContent:'';
const update=()=>{const variant=variants.find(item=>String(item.id)===String(idField.value))||variants[0];const plan=variant.plan;if(subOption)subOption.hidden=!plan;if(!plan&&subRadio&&subRadio.checked)oneRadio.checked=true;const subscribed=Boolean(plan&&subRadio&&subRadio.checked);const unit=subscribed?plan.price:variant.price;planField.value=subscribed?plan.id:'';planField.disabled=!subscribed;find('[data-in-price]').textContent=formatMoney(unit,moneyWithCurrency);const compare=find('[data-in-compare]');if(compare){const compareAt=subscribed?variant.price:variant.compare;compare.hidden=!(compareAt>unit);compare.textContent=compareAt>unit?formatMoney(compareAt,money):'';}
root.querySelectorAll('.in-pack').forEach(pack=>{const count=Number(pack.querySelector('input').value)||1;const price=pack.querySelector('[data-in-pack-price]');if(price)price.textContent=formatMoney(unit*count,money);});const oneTimePrice=find('[data-in-one-price]');if(oneTimePrice)oneTimePrice.textContent=formatMoney(variant.price,money);
if(plan){find('[data-in-sub-price]').textContent=formatMoney(plan.price,money);find('[data-in-sub-compare]').textContent=formatMoney(variant.price,money);find('[data-in-sub-name]').textContent=plan.cadence||plan.name;const save=Math.round((variant.price-plan.price)/variant.price*100);find('[data-in-sub-save]').textContent=save>0?`Save ${save}%`:'';}
if(modeLabel)modeLabel.textContent=subscribed?'Subscribe & save':oneTimeText;if(note){note.hidden=!subscribed;note.textContent=subscribed?`${plan.cadence||plan.name}. Renews automatically at ${formatMoney(plan.price,money)} per delivery, plus any shipping and taxes, until you cancel. Skip, pause, or cancel anytime.`:'';}};
form.addEventListener('change',update);update();};const run=()=>document.querySelectorAll('[data-innareve-product]').forEach(setup);if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',run);}else{run();}document.addEventListener('shopify:section:load',run);})();

  } catch(e) { console.error(e); }
})();
})();
